import { useContractFunction, useEthers } from "@usedapp/core";
import { ethers } from "ethers";
import * as React from "react";
import { useEffect, useState } from "react";
import { ABI } from "../../abi";
import useIsOnSale from "../../hooks/useIsOnSale";
import useMintedTokenIdList from "../../hooks/useMintedTokenIdList";
import { PageTemplate } from "../templates";

export const price = ethers.utils.parseEther("0.03");

const PurchasePage = () => {
  const { account, chainId } = useEthers();
  const mintedIdList = useMintedTokenIdList();
  const [onSaleTokenIdList, setOnSaleTokenIdList] = useState<number[]>([]);
  const [tokenId, setTokenId] = useState<number>(-1);
  const randomId = React.useMemo(() => {
    return Math.floor(Math.random() * 666);
  }, []);

  const contractAddress = process.env.REACT_APP_NFT_ADDRESS ?? "";

  const isOnSale = useIsOnSale();

  const contract = new ethers.Contract(contractAddress, ABI);
  const { send: buy, state: buyState, events: buyEvents } = useContractFunction(
    contract,
    "buy"
  );

  useEffect(() => {
    if (mintedIdList === undefined) {
      return;
    }
    const mintedNumbers = mintedIdList.map((id) => id.toNumber());
    const ids = [...Array(666)]
      .map((_, index) => index + 1)
      .filter((id) => !mintedNumbers.includes(id))
      .sort(() => 0.5 - Math.random());
    setOnSaleTokenIdList(ids);
    if (tokenId !== -1) {
      return;
    } else {
      setTokenId(ids[0]);
    }
  }, [tokenId, mintedIdList, setTokenId, setOnSaleTokenIdList]);

  const isSoldOut =
    mintedIdList !== undefined &&
    mintedIdList.length === 0 &&
    onSaleTokenIdList.length === 0;

  return (
    <PageTemplate
      isConnected={!!account}
      buy={buy}
      transactionStatus={buyState}
      isPurchasing={false}
      chainId={chainId}
      account={account}
      tokenId={isSoldOut ? randomId : tokenId ?? randomId}
      // @ts-ignore
      getTokenId={buyState.receipt?.events[0].args.tokenId.toNumber()}
      isOnSale={isOnSale}
      isSoldOut={isSoldOut}
    />
  );
};

export default PurchasePage;
